export const limitOptions = [
  {
    value: 5,
    title: 5,
  },
  {
    value: 10,
    title: 10,
  },
  {
    value: 15,
    title: 15,
  },
];
